// 子任务

// 课程或者作业页面
const SubCommon = r => require.ensure(
  [],
  () => r(require('@/components/sub-task/common/common.vue')),
  'SubCommon'
)

// 练习
const Exercise = r => require.ensure(
  [],
  () => r(require('@/components/sub-task/common/exercise.vue')),
  'SubCommonexErcise'
)
// 创建团队
const CreateTeam = r => require.ensure(
  [],
  () => r(require('@/components/bloom-team/create-team')),
  'SubTeam'
)
// 团队入口
const FormTeam = r => require.ensure(
  [],
  () => r(require('@/components/bloom-team/team-entry')),
  'SubTeam'
)

// 加入团队
const JoinTeam = r => require.ensure(
  [],
  () => r(require('@/components/bloom-team/team-join')),
  'SubTeam'
)
export default [
  // 课程或者作业
  {
    path: '/TaskSublist/SubCommon',
    name: 'CommonCourse',
    component: SubCommon
  },
  // 练习
  {
    path: '/TaskSublist/exercise',
    name: 'exercise',
    component: Exercise
  },
  // 创建团队
  {
    path: '/TaskSublist/createTeam',
    name: 'createTeam',
    component: CreateTeam
  },
  // 组队
  {
    path: '/TaskSublist/formTeam',
    name: 'formTeam',
    component: FormTeam
  },
  // 加入团队
  {
    path: '/TaskSublist/joinTeam',
    name: 'joinTeam',
    component: JoinTeam
  }
]



// WEBPACK FOOTER //
// ./src/router/sub-route/sub-task.js